import { render, staticRenderFns } from "./IcMinus.vue?vue&type=template&id=6ee31488&scoped=true"
import script from "./IcMinus.vue?vue&type=script&lang=js"
export * from "./IcMinus.vue?vue&type=script&lang=js"
import style0 from "./IcMinus.vue?vue&type=style&index=0&id=6ee31488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee31488",
  null
  
)

export default component.exports